// MIT © 2017 azu
export function openURLinNewWindow(url: string) {
    window.open(url, "_blank");
}



// WEBPACK FOOTER //
// ./src/infra/window/WindowOpen.ts